import { Platform } from "react-native";
import type { useHotkeys as t, Options } from "react-hotkeys-hook";
import { useIsFocused } from "@react-navigation/native";

type Args = Parameters<typeof t>;

export let useHotkeys = (
  keys: Args[0],
  callback: Args[1],
  options?: Options
): any => {};

if (Platform.OS === "web") {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const useHotkeysF = require("react-hotkeys-hook").useHotkeys;

  useHotkeys = function useHotkeysWeb(
    keys: Args[0],
    callback: Args[1],
    options?: Options
  ) {
    const isInFocus = useIsFocused();
    return useHotkeysF(keys, callback, {
      ...options,
      enabled: options?.enabled !== false && isInFocus,
    });
  };
}
